import { AxiosError, AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import useSWR, { mutate } from 'swr';

import Config from '../../shared/config';
import CourseVersion from '../../content/models/CourseVersion';
import CourseVersionMap from 'content/models/CourseVersionMap';

export function useCourses(coursekey: number) {
  const [liveVersion, setLiveVersion] = useState(0);
  const [liveVersionMap, setLiveVersionMap] = useState<
    CourseVersionMap[] | undefined
  >([]);

  const publishedVersionUrl = coursekey
    ? `${Config.API}/api/course/list/course/${coursekey}/version/published`
    : null;

  const liveCourseMapUrl =
    coursekey && liveVersion
      ? `${Config.API}/api/module/list/map/course/${coursekey}/version/${liveVersion}`
      : null;

  const {
    data: response,
    error,
    isValidating
  } = useSWR<AxiosResponse<CourseVersion[]>, AxiosError<Error>>(
    publishedVersionUrl
  );

  useEffect(() => {
    if (response) {
      const courses = response?.data ?? [];
      setLiveVersion([...courses].pop()?.courseversion ?? 0);
    }
  }, [response]);

  const {
    data: versionMapResponse,
    error: versionMapError,
    isValidating: versionMapIsValidating
  } = useSWR<AxiosResponse<CourseVersionMap[]>, AxiosError<Error>>(
    liveCourseMapUrl
  );

  useEffect(() => {
    if (liveVersion && versionMapResponse) {
      setLiveVersionMap(versionMapResponse.data);
    }
  }, [versionMapResponse]);

  const getPublishedCourse = async () => {
    await mutate(publishedVersionUrl);
  };

  const getCourseVersionMap = async () => {
    await mutate(liveCourseMapUrl);
  };

  const refetchCourseInfo = async () => {
    await getPublishedCourse();
    await getCourseVersionMap();
  };

  return {
    courses: response?.data ?? [],
    liveVersion,
    liveVersionMap,
    loading: isValidating || versionMapIsValidating,
    error: error || versionMapError,
    refetchCourseInfo
  };
}
